import React, { Component } from 'react';
import Game2dMenu from './Controls/Game2dMenu';
import HotelObserver from './Components/Views/HotelObserver';
import HotelObserverScoreBars from './Components/Views/HotelObserverScoreBars';
import TheRiver from './Components/Controls/TheRiver';
import { useCompetitorTargeting } from '../Dashboard/useCompetitorTargeting';

import './game.css';


// CompetitorGrid is the mobile / 2D consumer of the competitor-target
// subsystem. Game2d is a class component and cannot call the hook
// directly, so the grid lives in this small local function component.
// It is NOT a shared parent wrapper across surfaces — desktop's
// CompetitorsWindow calls the hook independently; this is mobile's own
// call. When no target pick is open every board renders exactly as
// before (isTargetCandidate false, onTargetClick inert).
function CompetitorGrid(props) {
    const { isTargetCandidate, onTargetClick } = useCompetitorTargeting();
    return (
        <div className={'competitor-grid'}>
            {props.seatedPlayers.map((gamePlayerData, key) => {
                return <HotelObserver key={key}
                                      gamePlayerData={gamePlayerData}
                                      isActive={props.activePlayer === gamePlayerData.id}
                                      isTargetCandidate={isTargetCandidate(gamePlayerData.id)}
                                      onTargetClick={() => onTargetClick(gamePlayerData.id)}
                />
            })}
        </div>
    );
}


function isPreGameStart(gameData) {
    const OPEN_ID = 15;
    const LOBBY_ID = 16;
    const STARTING_ID = 1;
    // const STARTED_ID = 2;
    let preStart = [OPEN_ID, LOBBY_ID, STARTING_ID];
    return (preStart.includes(gameData.status));
}


export default class Game2d extends Component  {

    render() {
        if (!this.props.gameData) {
            return <></>;
        }
        let activePlayer = this.props.gameData.active_player;
        // Only render seats that have actually picked a faction. An
        // empty seat (faction === null) means either the seat is
        // unfilled in a sub-6-player lobby, or the player hasn't yet
        // chosen their faction in the in-game ceremony. Rendering an
        // empty bordered board for those wastes screen real estate —
        // Michael's directive: hide the placeholder, surface the
        // active players.
        let seatedPlayers = this.props.gameData.gameplayer_set.filter(
            (gp) => gp.faction !== null && gp.faction !== undefined
        );

        return (
            <div id={'Game2d'} className={'game-class'}>
                <Game2dMenu {...this.props} />
                <CompetitorGrid seatedPlayers={seatedPlayers}
                                activePlayer={activePlayer}/>
                {!this.props.gamePlayerData &&
                <div className={'game-second-row'}>
                    <HotelObserverScoreBars {...this.props}/>
                    <div className={'game-tradelanes'}>
                        <TheRiver {...this.props} bind={false}/>
                        {/* <AnimatedTradelanesObserver {...this.props} /> */}
                    </div>
                </div>
                }
            </div>
        );
    }


}
